import { AnyAction } from '@reduxjs/toolkit';
import { FetchPermissionsRoutine } from '../redux-routines';
import { loadLocalStoreData } from '../../../services/local-storage.service';
import { IUserAbilitiesState } from '../interfaces';

const initialState: IUserAbilitiesState = {
  isFetching: false,
  permissions: loadLocalStoreData('permissions', [], true),
  error: null,
};

export const userAbilitiesReducer = (
  state: IUserAbilitiesState = initialState,
  action: AnyAction,
): IUserAbilitiesState => {
  switch (action.type) {
    case FetchPermissionsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        permissions: action.payload,
        error: null,
      };
    case FetchPermissionsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchPermissionsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
